import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

export const FOR_MONITORING_REDUCER_NAME = "for-monitoring-report";

const initialState = {
  page: 0,
  take: 20,
  totalCount: 0,
  data: [],
  filters: {
    flagId: "",
    assignee: "",
    resolutionStatus: "",
    executionCheck: "",
    tenant: "",
    resolutionDateFrom: "",
    resolutionDateTo: "",
    dueDateFrom: "",
    dueDateTo: "",
  },
};

const forMonitoringSlice = createSlice({
  name: FOR_MONITORING_REDUCER_NAME,
  initialState,
  reducers: {
    setForMonitoringData: (state, { payload }) => {
      state.data = [...payload];
    },
    setForMonitoringPage: (state, { payload }) => {
      state.page = parseInt(payload, 10);
    },
    setForMonitoringTake: (state, { payload }) => {
      state.take = parseInt(payload, 10);
    },
    setForMonitoringTotalCount: (state, { payload }) => {
      state.totalCount = parseInt(payload, 10);
    },
    setForMonitoringFilters: (state, { payload }) => {
      state.filters = { ...state.filters, ...payload };
      state.page = 0;
    },
    clearForMonitoring: (state) => {
      state.page = initialState.page;
      state.take = initialState.take;
      state.totalCount = initialState.totalCount;
      state.data = initialState.data;
      state.filters = { ...initialState.filters };
    },
  },
});

export const {
  setForMonitoringData,
  setForMonitoringPage,
  setForMonitoringTake,
  setForMonitoringTotalCount,
  setForMonitoringFilters,
  clearForMonitoring,
} = forMonitoringSlice.actions;

export default forMonitoringSlice.reducer;

export const useSelectPageForMonitoring = () =>
  useSelector((state) => state[FOR_MONITORING_REDUCER_NAME].page);

export const useSelectTakeForMonitoring = () =>
  useSelector((state) => state[FOR_MONITORING_REDUCER_NAME].take);

export const useSelectTotalCountForMonitoring = () =>
  useSelector((state) => state[FOR_MONITORING_REDUCER_NAME].totalCount);

export const useSelectDataForMonitoring = () =>
  useSelector((state) => state[FOR_MONITORING_REDUCER_NAME].data);

export const useSelectFiltersForMonitoring = () =>
  useSelector((state) => state[FOR_MONITORING_REDUCER_NAME].filters);
